import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BlankReceiptRequest } from 'app/core/store/blank-receipts/blank-receipts.interface';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { Definition } from '../../../core/store/definitions/definition.interface';

@Component({
  selector: 'app-blank-receipt-form',
  templateUrl: './blank-receipt-form.component.html',
  styleUrls: ['./blank-receipt-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // don't always check for changes, only when input changed (but there's no input here)
})
export class BlankReceiptFormComponent implements OnInit, OnChanges {
  blankReceiptForm: UntypedFormGroup;
  shipTosLoading = false;

  @Input() receiptTypes: Definition[];
  @Input() isSaving: boolean;
  @Input() shipTos: Definition[];
  @Input() customers: Customer[];
  @Input() showSelectCustomers: boolean;
  @Output() createBlankReceipts = new EventEmitter<BlankReceiptRequest>();
  @Output() customerSelected = new EventEmitter<string>();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.customers) {
      if (this.customers && this.customers.length === 1) {
        this.selectCustomer(this.customers[0]);
      }
    }
    if (changes.shipTos) {
      this.shipTosLoading = false;
      const theOnlyShipTo = this.shipTos && this.shipTos.length === 1 && this.shipTos[0];
      if (theOnlyShipTo && this.blankReceiptForm) {
        this.blankReceiptForm.get('shipToId').setValue(theOnlyShipTo?.id);
      }
    }
  }

  private createForm() {
    const theOnlyCustomer = this.customers && this.customers.length === 1 && this.customers[0];
    if (!theOnlyCustomer) {
      this.shipTos = null;
    }
    const theOnlyShipTo = this.shipTos && this.shipTos.length === 1 && this.shipTos[0];
    this.blankReceiptForm = this.formBuilder.group({
      type: [this.receiptTypes[0].id, [Validators.required]],
      quantity: ['', [Validators.required]],
      shipToId: [theOnlyShipTo?.id || null, [Validators.required]],
      customerId: [theOnlyCustomer?.id || null, [Validators.required]],
    });
  }

  customerSelectionChanged() {
    const customerValue = this.blankReceiptForm.get('customerId').value;
    this.shipTosLoading = true;
    this.customerSelected.emit(customerValue);
    this.blankReceiptForm.get('shipToId').setValue(null);
  }

  createReceipts() {
    if (!this.blankReceiptForm.invalid && !this.isSaving) {
      this.createBlankReceipts.emit(this.blankReceiptForm.value);

      // clear the form
      this.createForm();
    }
  }

  private selectCustomer(customer: Customer) {
    this.customerSelected.emit(customer?.id);
    if (this.blankReceiptForm) {
      this.blankReceiptForm.get('customerId').setValue(customer?.id);
    }
  }
}
